var exports = {
  "p": "FeedbackLinkWrapper__URxZOU",
  "M": "SidebarDivider__R8jjcp",
};

module.exports = exports;
